/**
 * Kenya location helpers for Phase 1 UI (Country fixed as Kenya).
 * Regions load from master_region API.
 * Counties for a region load from master county API (?regionId=).
 */
export const KENYA_COUNTRY_ID = 125;
export const KENYA_COUNTRY_NAME = 'Kenya';

export function unwrapLocationList(response) {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data?.data?.data)) return response.data.data.data;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  if (Array.isArray(response?.data)) return response.data;
  return [];
}

export function locationOptionId(item) {
  return item?.id ?? item?.countyId ?? item?.subCountyId ?? item?.regionId ?? '';
}

export function locationOptionName(item) {
  return item?.name || item?.countyName || item?.subCountyName || item?.regionName || '';
}
